<div class="application-view-main-container application-view-main-container-narrower">
  <div class="texts-container">
    <p class="landing-page-text text-centered text-primary-color">Kontaktowy adres email:</p>
    <p class="landing-page-text text-centered text-black">kontakt&#64;pana-store.pl</p>
  </div>
</div>

